// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"8a860b3d","36":"84a7c2ea","116":"8a860b3d","697":"75b37c49","809":"3a259777"}[chunkId] + ".chunk.css";
};